import MentoringIcon from './MentoringIcon.vue';

export default MentoringIcon;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/icon/index.ts